import {
  MenuLayoutEnum,
  MenuTemplateEnum,
} from '../../../__generated__/graphql'
import {
  MenuBlockTypeEnum,
  StarOfTheCraftersBlockModel,
} from '../../pages/pub-menu/create/builder/models'

export const getImagesColorByTemplate = (
  template: MenuTemplateEnum,
  blockType: StarOfTheCraftersBlockModel['type']
): string => {
  switch (template) {
    case MenuTemplateEnum.Black:
    case MenuTemplateEnum.Black2:
      if (blockType !== MenuBlockTypeEnum.ColoredStarOfTheCraftersBlock) {
        return 'white'
      }
      return 'colored'

    default:
      if (blockType !== MenuBlockTypeEnum.ColoredStarOfTheCraftersBlock) {
        return 'black'
      }
      return 'colored'
  }
}

export const getLogoSizeByLayout = (layout: MenuLayoutEnum): number => {
  switch (layout) {
    case MenuLayoutEnum.A5:
      return 55

    case MenuLayoutEnum.A6:
      return 35

    default:
      return 100
  }
}

export const getTitleSizeByLayout = (layout: MenuLayoutEnum): number => {
  switch (layout) {
    case MenuLayoutEnum.A5:
      return 15

    case MenuLayoutEnum.A6:
      return 9

    default:
      return 20
  }
}

export const getItemTitleSizeByLayout = (layout: MenuLayoutEnum): number => {
  switch (layout) {
    case MenuLayoutEnum.A5:
      return 12

    case MenuLayoutEnum.A6:
      return 9

    default:
      return 14
  }
}

export const getItemTitleSpacingByLayout = (layout: MenuLayoutEnum): number => {
  switch (layout) {
    case MenuLayoutEnum.A5:
    case MenuLayoutEnum.A6:
      return 0

    default:
      return 5
  }
}

export const getDescriptionSizeByLayout = (layout: MenuLayoutEnum): number => {
  switch (layout) {
    case MenuLayoutEnum.A5:
      return 8

    case MenuLayoutEnum.A6:
      return 7

    default:
      return 13
  }
}

export const getSpacingsByLayout = (layout: MenuLayoutEnum): number => {
  switch (layout) {
    case MenuLayoutEnum.A5:
      return 2

    case MenuLayoutEnum.A6:
      return 1

    default:
      return 3.5
  }
}

export const getItemImageSizeByLayout = (layout: MenuLayoutEnum): number => {
  switch (layout) {
    case MenuLayoutEnum.A5:
      return 50

    case MenuLayoutEnum.A6:
      return 25

    default:
      return 75
  }
}

export const getItemImagePDFWidthByLayout = (
  layout: MenuLayoutEnum
): number => {
  switch (layout) {
    case MenuLayoutEnum.A5:
      return 70

    case MenuLayoutEnum.A6:
      return 35

    default:
      return 90
  }
}

export const getItemTextPDFWidthByLayout = (layout: MenuLayoutEnum): number => {
  switch (layout) {
    case MenuLayoutEnum.A5:
      return 280

    case MenuLayoutEnum.A6:
      return 180

    default:
      return 400
  }
}
